// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + "algolia-search" + ".js?" + "532740e38e5746d9c478" + "";
};